const LOCAL_ENDPOINT = 'http://localhost:5000/re-drive-75970/us-central1/app/yll';
const REMOTE_ENDPOINT = 'https://us-central1-re-drive-75970.cloudfunctions.net/app/yll';

const local = 0;
const url = process.env.NODE_ENV === 'production' || !local ? REMOTE_ENDPOINT : LOCAL_ENDPOINT;

export default {
  url,
};
